import { useMyPortfolioCapsulesConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { useServices } from 'app/hooks';
import { useWidgetContext } from 'widgets/WidgetContext';
import { MyPortfolioCapsulesDataItem } from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesData';
import { useEffect, useState } from 'react';

/*
 * Registers the symbol streams for the symbols in the MyPortfolioCapsules data
 */
export function useMyPortfolioCapsuleStreams(
    data: MyPortfolioCapsulesDataItem[]
) {
    const { widgetKey } = useWidgetContext();
    const { config } = useMyPortfolioCapsulesConfigSlice();
    const { capsuleType } = config;
    const { widgetStreamingService } = useServices();

    const [registeredWidgetType, setRegisteredWidgetType] =
        useState(capsuleType);

    useEffect(() => {
        widgetStreamingService.registerSymbolStreams(
            widgetKey,
            registeredWidgetType!,
            data.map((d) => d.symbol),
            config,
            data.map((d) => d.qty)
        );
    }, [config, data, registeredWidgetType, widgetStreamingService, widgetKey]);

    useEffect(() => {
        // When the capsule type changes we deregister the previous and register the next...
        widgetStreamingService.dispose(registeredWidgetType!, widgetKey);
        setRegisteredWidgetType(capsuleType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [capsuleType, widgetStreamingService, widgetKey]);
}
